var interval;
$(document).ready(function(){
  console.log("eeee");
  interval = setInterval(hideButtons,10);
  $(".google_flex1 .google").click(function(){
    console.log("fff");
    $(".h_google_rect").trigger("click");
  });
  $(".google_flex1 .twtter").click(function(){
    $(".h_twitter_rect").trigger("click");
  });
  $(".google_flex1 .facebook2").click(function(){
    $(".h_facebook_rect").trigger("click");
  }); 
});
function hideButtons(){
  if ($(".h_buttons").length) {  
    $(".h_buttons").css("display","none");
    clearInterval(interval);
  }
}

